import { CommitedClubMemberEntity } from "@/modules/boxDashboard/modules/CommitedClub/entities/commitedClubMemberEntity"
import { useServicesContext } from "@modules/core/services/services.context"
import { useSuspenseQuery } from "@tanstack/react-query"
import dayjs from "dayjs"

export const CommitedClubPeriodTypes = ["MONTH", "YEAR"] as const
export type CommitedClubPeriodType = (typeof CommitedClubPeriodTypes)[number]

export type CommitedClubPeriod = {
  periodType: CommitedClubPeriodType
  year: number
  month?: number
}

const COMMITED_CLUB_QUERY_KEY = ["commitedClubMembers"]

const getDefaultPeriod = (): CommitedClubPeriod => {
  const now = dayjs()
  return {
    periodType: "MONTH",
    year: now.year(),
    month: now.month() + 1,
  }
}

export function useCommitedClub(period: CommitedClubPeriod | undefined) {
  const { boxDashboardApi } = useServicesContext()
  const effectivePeriod = period ?? getDefaultPeriod()

  const query = useSuspenseQuery({
    queryKey: [
      ...COMMITED_CLUB_QUERY_KEY,
      effectivePeriod,
      effectivePeriod.periodType,
      effectivePeriod.year,
      effectivePeriod.month ?? null,
    ],
    queryFn: async () => {
      const dto = await boxDashboardApi.getCommitedClub(effectivePeriod)
      return dto.content.map((item) => CommitedClubMemberEntity.fromDto(item))
    },
  })

  return {
    members: query.data,
  }
}

export function getDefaultCommitedClubPeriod() {
  return getDefaultPeriod()
}
